import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addUserActivity,
  selectUserActivity,
  togglePreference,
} from "../../../redux/slices/userActivity";
import "./activity.css";
import ActivityBox from "./activityBox";
import Preference from "./Preference/Preference";
import Video from "./Video/Video";
import CrossWords from "./_games/CrossWords";

//will display the activity the user is creating
export default function Activity() {
  const { userActivities, selectedUserActivity, isVideo, preferenceActive } = useSelector((state) => state.userActivity);
  const activity = userActivities[selectedUserActivity];
  // console.log('userActivities', userActivities)
  // console.log('selectedUserActivity', selectedUserActivity)

  const dispatch = useDispatch();

  const selectPrevActivity = () => {
    if (selectedUserActivity <= 0) return;
    dispatch(selectUserActivity(selectedUserActivity - 1));
  };
  const selectNextActivity = () => {
    if (selectedUserActivity >= userActivities.length - 1) return;
    dispatch(selectUserActivity(selectedUserActivity + 1));
  };

  const addVideoActivity = () => {
    dispatch(togglePreference({
      preferenceActive: true,
      defaultPreference: { timestamp: 0, dropdownId: 1 },
      preferenceEditing: false
    }))
  }

  const handleAddActivity = () => {
    if (isVideo) {
      addVideoActivity()
      return
    }
    dispatch(addUserActivity({}))
  }
  // console.log(userActivities);
  return (
    <div className="activity_container__activity_main">
      <button
        className="activity_container__slide_change_btn prev_slide_btn"
        disabled={selectedUserActivity <= 0}
        onClick={selectPrevActivity}
      >
        <svg
          width={10}
          height={18}
          viewBox="0 0 18 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.2811 31.2601C18.2396 30.2735 18.2396 28.6739 17.2811 27.6873L5.9258 16L17.2811 4.31269C18.2396 3.32611 18.2396 1.72653 17.2811 0.739943C16.3225 -0.246647 14.7684 -0.246647 13.8098 0.739943L0.71892 14.2136C-0.23964 15.2002 -0.23964 16.7998 0.71892 17.7864L13.8098 31.2601C14.7684 32.2466 16.3225 32.2466 17.2811 31.2601Z"
            fill="black"
          />
        </svg>
      </button>
      {
        // preferenceActive ? <div className="activity_container__activity"
        //   style={{ background: '#fff', overflow: 'auto' }}>
        //   <Preference />
        // </div>
        //   :

        activity && (Object.keys(activity).length < 2 || !activity) ? (
          <div className="activity_container__activity">
            <div
              className="activity_container__activity_wrapper"
              style={{ backgroundColor: "#efefef" }}
            ></div>
          </div>
        ) :
          (
            <ActivityBox master={activity} />
          )
      }
      {selectedUserActivity >= userActivities.length - 1 ? (
        <button
          className="activity_container__slide_change_btn next_slide_btn"
          onClick={() => handleAddActivity()}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.14293 1.53423C8.14293 1.08143 7.75917 0.714355 7.28578 0.714355C6.8124 0.714355 6.42864 1.08143 6.42864 1.53423V6.18019H1.5715C1.09811 6.18019 0.714355 6.54726 0.714355 7.00007C0.714355 7.45287 1.09811 7.81995 1.5715 7.81995H6.42864V12.4659C6.42864 12.9187 6.8124 13.2858 7.28578 13.2858C7.75917 13.2858 8.14293 12.9187 8.14293 12.4659V7.81995H13.0001C13.4735 7.81995 13.8572 7.45288 13.8572 7.00007C13.8572 6.54727 13.4735 6.18019 13.0001 6.18019H8.14293V1.53423Z"
              fill="black"
            />
          </svg>
        </button>
      ) : (
        <button
          className="activity_container__slide_change_btn next_slide_btn"
          disabled={selectedUserActivity >= userActivities.length - 1}
          onClick={selectNextActivity}
        >
          <svg
            width={10}
            height={18}
            viewBox="0 0 10 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.583619 0.861432C1.09485 0.335252 1.92372 0.335252 2.43495 0.861432L9.41677 8.0474C9.928 8.57358 9.928 9.42668 9.41677 9.95286L2.43495 17.1388C1.92372 17.665 1.09485 17.665 0.583619 17.1388C0.0723874 16.6126 0.0723874 15.7595 0.583619 15.2334L6.63977 9.00013L0.583619 2.7669C0.0723874 2.24072 0.0723874 1.38761 0.583619 0.861432Z"
              fill="black"
            />
          </svg>
        </button>
      )}
    </div>
  );
}
